import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase';

function OzelRaporlar({ sube }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const subeFromUrl = queryParams.get('sube') || 'Bilinmeyen Şube';
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [raporData, setRaporData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const categories = [
    {
      key: 'sarrafiye',
      name: 'Sarrafiye',
      field: 'adet',
      productWidth: '175px',
      totalWidth: '355px',
      items: [
        { key: 'eskiZiynetCeyrek', label: 'Eski Ziynet Çeyrek' },
        { key: 'yeniZiynetCeyrek', label: 'Yeni Ziynet Çeyrek' },
        { key: 'eskiZiynetYarim', label: 'Eski Ziynet Yarım' },
        { key: 'yeniZiynetYarim', label: 'Yeni Ziynet Yarım' },
        { key: 'eskiZiynetTam', label: 'Eski Ziynet Tam' },
        { key: 'yeniZiynetTam', label: 'Yeni Ziynet Tam' },
        { key: 'eskiZiynetGremse', label: 'Eski Ziynet 2.5\'lu Gremse' },
        { key: 'yeniZiynetGremse', label: 'Yeni Ziynet 2.5\'lu Gremse' },
        { key: 'eskiZiynetBesli', label: 'Eski Ziynet Beşli' },
        { key: 'yeniZiynetBesli', label: 'Yeni Ziynet Beşli' },
        { key: 'cumhuriyetAtaCeyrek', label: 'Cumhuriyet Ata Çeyrek' },
        { key: 'cumhuriyetAtaYarim', label: 'Cumhuriyet Ata Yarım' },
        { key: 'cumhuriyetAta', label: 'Cumhuriyet Ata' },
        { key: 'cumhuriyetAtaGremse', label: 'Cumhuriyet Ata 2.5\'lu Gremse' },
        { key: 'cumhuriyetAtaBesli', label: 'Cumhuriyet Ata Beşli' },
        { key: 'resatCeyrek', label: 'Reşat Çeyrek' },
        { key: 'resatYarim', label: 'Reşat Yarım' },
        { key: 'resat', label: 'Reşat' },
        { key: 'resatGremse', label: 'Reşat 2.5\'lu Gremse' },
        { key: 'resatBesli', label: 'Reşat Beşli' }
      ]
    },
    {
      key: 'gramAltin',
      name: 'Gram Altın',
      field: 'adet',
      productWidth: '130px',
      totalWidth: '310px',
      items: [
        { key: 'birGram22Ayar', label: '1 Gram 22 Ayar' },
        { key: 'yariGram22Ayar', label: '0.50 Gram 22 Ayar' },
        { key: 'ceyrekGram22Ayar', label: '0.25 Gram 22 Ayar' },
        { key: 'birGram24Ayar', label: '1 Gram 24 Ayar' },
        { key: 'yariGram24Ayar', label: '0.50 Gram 24 Ayar' },
        { key: 'ceyrekGram24Ayar', label: '0.25 Gram 24 Ayar' },
        { key: 'ikiBucukGram24Ayar', label: '2.50 Gram 24 Ayar' },
        { key: 'besGram24Ayar', label: '5 Gram 24 Ayar' },
        { key: 'onGram24Ayar', label: '10 Gram 24 Ayar' },
        { key: 'yirmiGram24Ayar', label: '20 Gram 24 Ayar' },
        { key: 'elliGram24Ayar', label: '50 Gram 24 Ayar' },
        { key: 'yuzGram24Ayar', label: '100 Gram 24 Ayar' }
      ]
    },
    {
      key: 'hurda',
      name: 'Hurda',
      field: 'gram',
      productWidth: '135px',
      totalWidth: '315px',
      items: [
        { key: 'yirmiDortAyarHurda', label: '24 Ayar Hurda' },
        { key: 'yirmiIkiAyarBilezikHurda', label: '22 Ayar Bilezik Hurda' },
        { key: 'yirmiIkiAyarHurda', label: '22 Ayar Hurda' },
        { key: 'yirmiBirAyarHurda', label: '21 Ayar Hurda' },
        { key: 'onSekizAyarHurda', label: '18 Ayar Hurda' },
        { key: 'onDortAyarHurda', label: '14 Ayar Hurda' },
        { key: 'onAyarHurda', label: '10 Ayar Hurda' },
        { key: 'sekizAyarHurda', label: '8 Ayar Hurda' }
      ]
    },
    {
      key: 'doviz',
      name: 'Döviz',
      field: 'birim',
      productWidth: '210px',
      totalWidth: '390px',
      items: [
        { key: 'tl', label: 'TL - Türk Lirası' },
        { key: 'usd', label: 'USD - Amerikan Doları' },
        { key: 'eur', label: 'EUR - Euro' },
        { key: 'gbp', label: 'GBP - İngiliz Sterlini' },
        { key: 'chf', label: 'CHF - İsviçre Frangı' },
        { key: 'aud', label: 'AUD - Avustralya Doları' },
        { key: 'cad', label: 'CAD - Kanada Doları' },
        { key: 'sar', label: 'SAR - Suudi Arabistan Riyali' },
        { key: 'aed', label: 'AED - Birleşik Arap Emirlikleri Dirhemi' },
        { key: 'qar', label: 'QAR - Katar Riyali' },
        { key: 'mad', label: 'MAD - Fas Dirhemi' },
        { key: 'jod', label: 'JOD - Ürdün Dinarı' },
        { key: 'kwd', label: 'KWD - Kuveyt Dinarı' },
        { key: 'cny', label: 'CNY - Çin Yuanı' },
        { key: 'rub', label: 'RUB - Rus Rublesi' },
        { key: 'bgn', label: 'BGN - Bulgar Levası' }
      ]
    },
    {
      key: 'takiUrun',
      name: 'Takı Ürün',
      field: 'gram',
      productWidth: '100px',
      totalWidth: '280px',
      items: [
        { key: 'yirmiIkiAyarBilezik', label: '22 Ayar Bilezik' },
        { key: 'onDortAyarBilezik', label: '14 Ayar Bilezik' },
        { key: 'sekizAyarBilezik', label: '8 Ayar Bilezik' },
        { key: 'yirmiIkiAyarTaki', label: '22 Ayar Takı' },
        { key: 'yirmiBirAyarTaki', label: '21 Ayar Takı' },
        { key: 'onSekizAyarTaki', label: '18 Ayar Takı' },
        { key: 'onDortAyarTaki', label: '14 Ayar Takı' },
        { key: 'sekizAyarTaki', label: '8 Ayar Takı' }
      ]
    }
  ];

  useEffect(() => {
    const fetchRapor = async () => {
      if (!startDate || !endDate) return;
      setLoading(true);
      try {
        const start = new Date(startDate);
        const end = new Date(endDate);
        if (start > end) {
          setError('Başlangıç tarihi bitiş tarihinden sonra olamaz.');
          setLoading(false);
          return;
        }

        const kasaCollection = collection(db, 'subeler', sube || subeFromUrl, 'islemler');
        const kasaSnapshot = await getDocs(kasaCollection);
        const rapor = {};
        const toplamlar = {};
        categories.forEach((category) => {
          rapor[category.key] = {};
          toplamlar[category.key] = { alis: 0, satis: 0 };
          category.items.forEach((item) => {
            rapor[category.key][item.key] = { alis: { [category.field]: 0 }, satis: { [category.field]: 0 } };
          });
        });

        kasaSnapshot.docs.forEach((doc) => {
          const docDate = new Date(doc.id);
          if (docDate >= start && docDate <= end) {
            const data = doc.data();
            Object.keys(data).forEach((category) => {
              if (rapor[category]) {
                Object.keys(data[category]).forEach((item) => {
                  if (rapor[category][item]) {
                    const alis = data[category][item]?.alis?.[category.field] || 0;
                    const satis = data[category][item]?.satis?.[category.field] || 0;
                    rapor[category][item].alis[category.field] += alis;
                    rapor[category][item].satis[category.field] += satis;
                    toplamlar[category].alis += alis;
                    toplamlar[category].satis += satis;
                  }
                });
              }
            });
          }
        });

        setRaporData({ detay: rapor, toplamlar });
        setError('');
        setLoading(false);
      } catch (err) {
        console.error('Veri alma hatası:', err);
        setError(`Hata: ${err.message}`);
        setLoading(false);
      }
    };
    fetchRapor();
  }, [sube, subeFromUrl, startDate, endDate]);

  if (loading) {
    return (
      <div className="or-page or-page--state" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: "'Roboto', sans-serif"
      }}>
        <p style={{ 
          fontSize: '16px', 
          color: '#4b5563', 
          fontWeight: 'bold',
          padding: '10px 20px',
          backgroundColor: '#ffffff',
          borderRadius: '6px',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          Yükleniyor...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="or-page or-page--state" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontFamily: "'Roboto', sans-serif"
      }}>
        <p style={{ 
          fontSize: '16px', 
          color: '#dc2626', 
          fontWeight: 'bold',
          padding: '10px 20px',
          backgroundColor: '#ffffff',
          borderRadius: '6px',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {error}
        </p>
      </div>
    );
  }

  return (
    <div className="or-page" style={{
      backgroundColor: '#ffffff',
      borderRadius: '8px',
      padding: '4px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      border: '1px solid #e5e7eb',
      width: '1200px',
      height: '540px',
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      fontFamily: "'Roboto', sans-serif",
      margin: '-10px 0 4px 0'
    }}>
      <div className="or-date-row" style={{ marginBottom: '10px', display: 'flex', gap: '10px' }}>
        <div className="or-date-shell">
          <input
            type="date"
            className="or-date-input"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{
              padding: '6px',
              fontSize: '14px',
              fontFamily: "'Roboto', sans-serif",
              border: '1px solid #e5e7eb',
              borderRadius: '4px',
              outline: 'none',
              width: '200px'
            }}
          />
        </div>
        <div className="or-date-shell">
          <input
            type="date"
            className="or-date-input"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{
              padding: '6px',
              fontSize: '14px',
              fontFamily: "'Roboto', sans-serif",
              border: '1px solid #e5e7eb',
              borderRadius: '4px',
              outline: 'none',
              width: '200px'
            }}
          />
        </div>
      </div>
      {raporData && (
        <div className="or-report-scroll" style={{ flex: '1', overflowY: 'auto' }}>
          {categories.map((category) => (
            <div key={category.key} className="or-category-block" style={{ marginBottom: '20px' }}>
              <div className="or-cat-title">{category.name}</div>
              <div className="or-table-wrap">
              <table className="or-table" style={{
                width: '100%',
                borderCollapse: 'separate',
                borderSpacing: '0',
                fontSize: '11px',
                color: '#1f2937',
                lineHeight: '1.2',
                boxSizing: 'border-box',
                fontWeight: 'bold'
              }}>
                <thead>
                  <tr>
                    <th style={{ 
                      border: '1px solid #e5e7eb', 
                      borderRight: '1px solid #e5e7eb',
                      padding: '3px',
                      width: category.productWidth,
                      textAlign: 'left',
                      boxSizing: 'border-box',
                      fontWeight: 'bold'
                    }}>
                      Ürün
                    </th>
                    <th style={{ 
                      border: '1px solid #e5e7eb', 
                      borderRight: '1px solid #e5e7eb',
                      padding: '3px',
                      width: '60px',
                      textAlign: 'center',
                      boxSizing: 'border-box',
                      fontWeight: 'bold'
                    }}>
                      Alış
                    </th>
                    <th style={{ 
                      border: '1px solid #e5e7eb', 
                      borderRight: '1px solid #e5e7eb',
                      padding: '3px',
                      width: '60px',
                      textAlign: 'center',
                      boxSizing: 'border-box',
                      fontWeight: 'bold'
                    }}>
                      Satış
                    </th>
                    <th style={{ 
                      border: '1px solid #e5e7eb', 
                      borderRight: '1px solid #e5e7eb',
                      padding: '3px',
                      width: '60px',
                      textAlign: 'center',
                      boxSizing: 'border-box',
                      fontWeight: 'bold'
                    }}>
                      Net
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {category.items.map((item) => (
                    <tr key={item.key} className="or-data-row">
                      <td className="or-cell-product" data-label="Ürün" style={{ 
                        border: '1px solid #e5e7eb', 
                        borderRight: '1px solid #e5e7eb',
                        padding: '3px',
                        width: category.productWidth,
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        boxSizing: 'border-box',
                        fontWeight: 'bold'
                      }}>
                        {item.label}
                      </td>
                      <td className="or-cell-alis" data-label="Alış" style={{ 
                        border: '1px solid #e5e7eb', 
                        borderRight: '1px solid #e5e7eb',
                        padding: '3px',
                        width: '60px',
                        boxSizing: 'border-box',
                        textAlign: 'center'
                      }}>
                        {raporData.detay[category.key]?.[item.key]?.alis?.[category.field] || 0}
                      </td>
                      <td className="or-cell-satis" data-label="Satış" style={{ 
                        border: '1px solid #e5e7eb', 
                        borderRight: '1px solid #e5e7eb',
                        padding: '3px',
                        width: '60px',
                        boxSizing: 'border-box',
                        textAlign: 'center'
                      }}>
                        {raporData.detay[category.key]?.[item.key]?.satis?.[category.field] || 0}
                      </td>
                      <td className="or-cell-net" data-label="Net" style={{ 
                        border: '1px solid #e5e7eb', 
                        borderRight: '1px solid #e5e7eb',
                        padding: '3px',
                        width: '60px',
                        boxSizing: 'border-box',
                        textAlign: 'center'
                      }}>
                        {(raporData.detay[category.key]?.[item.key]?.alis?.[category.field] || 0) - (raporData.detay[category.key]?.[item.key]?.satis?.[category.field] || 0)}
                      </td>
                    </tr>
                  ))}
                  <tr className="or-total-row">
                    <td className="or-total-label" data-label="Toplam" style={{ 
                      border: '1px solid #e5e7eb', 
                      borderRight: '1px solid #e5e7eb',
                      padding: '3px',
                      width: category.productWidth,
                      boxSizing: 'border-box',
                      fontWeight: 'bold',
                      backgroundColor: '#e5e7eb'
                    }}>
                      Toplam {category.name}
                    </td>
                    <td className="or-total-alis" data-label="Alış" style={{ 
                      border: '1px solid #e5e7eb', 
                      borderRight: '1px solid #e5e7eb',
                      padding: '3px',
                      width: '60px',
                      boxSizing: 'border-box',
                      textAlign: 'center',
                      backgroundColor: '#e5e7eb'
                    }}>
                      {raporData.toplamlar[category.key]?.alis || 0}
                    </td>
                    <td className="or-total-satis" data-label="Satış" style={{ 
                      border: '1px solid #e5e7eb', 
                      borderRight: '1px solid #e5e7eb',
                      padding: '3px',
                      width: '60px',
                      boxSizing: 'border-box',
                      textAlign: 'center',
                      backgroundColor: '#e5e7eb'
                    }}>
                      {raporData.toplamlar[category.key]?.satis || 0}
                    </td>
                    <td className="or-total-net" data-label="Net" style={{ 
                      border: '1px solid #e5e7eb', 
                      borderRight: '1px solid #e5e7eb',
                      padding: '3px',
                      width: '60px',
                      boxSizing: 'border-box',
                      textAlign: 'center',
                      backgroundColor: '#e5e7eb'
                    }}>
                      {(raporData.toplamlar[category.key]?.alis || 0) - (raporData.toplamlar[category.key]?.satis || 0)}
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
          ))}
        </div>
      )}
      <style>{`
        .or-cat-title {
          display: none;
        }

        /* --- MOBİL: Özel Raporlar (masaüstü inline stillerine dokunulmaz) --- */
        @media (max-width: 1649px), (max-width: 1400px) and (any-pointer: coarse) {
          .or-page {
            width: 100% !important;
            max-width: 100% !important;
            min-width: 0 !important;
            height: auto !important;
            min-height: 0 !important;
            margin: 0 !important;
            padding: 8px 4px 80px !important;
            border-radius: 10px !important;
            overflow-x: hidden !important;
            box-sizing: border-box !important;
          }

          .or-page--state {
            height: auto !important;
            min-height: 50vh !important;
            padding: 24px 12px !important;
          }

          .or-date-row {
            flex-direction: column !important;
            gap: 8px !important;
            margin-bottom: 12px !important;
          }

          .or-date-shell {
            width: 100% !important;
          }

          .or-date-input {
            width: 100% !important;
            min-height: 44px !important;
            font-size: 16px !important;
            box-sizing: border-box !important;
            touch-action: manipulation;
          }

          .or-report-scroll {
            flex: none !important;
            overflow: visible !important;
          }

          .or-category-block {
            margin-bottom: 16px !important;
          }

          .or-cat-title {
            display: block !important;
            font-size: 14px !important;
            font-weight: 800 !important;
            color: #17385b !important;
            margin-bottom: 8px !important;
            padding: 8px 10px !important;
            background: linear-gradient(180deg, #f1f5f9 0%, #e2e8f0 100%) !important;
            border-radius: 8px !important;
            border: 1px solid #cbd5e1 !important;
          }

          .or-table-wrap {
            overflow: visible !important;
          }

          .or-table {
            width: 100% !important;
            min-width: 0 !important;
          }

          .or-table thead {
            display: none !important;
          }

          .or-table tbody tr.or-data-row {
            display: block !important;
            margin-bottom: 8px !important;
            border: 1px solid #e5e7eb !important;
            border-radius: 10px !important;
            overflow: hidden !important;
            background: #ffffff !important;
            box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05) !important;
          }

          .or-table tbody tr.or-data-row td {
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            gap: 10px !important;
            width: auto !important;
            padding: 9px 12px !important;
            border: none !important;
            border-bottom: 1px solid #f1f5f9 !important;
            text-align: right !important;
            font-size: 13px !important;
            white-space: normal !important;
            word-break: break-word !important;
          }

          .or-table tbody tr.or-data-row td:last-child {
            border-bottom: none !important;
          }

          .or-table tbody tr.or-data-row td::before {
            content: attr(data-label) !important;
            font-weight: 700 !important;
            color: #64748b !important;
            font-size: 12px !important;
            text-align: left !important;
            flex-shrink: 0 !important;
            margin-right: auto !important;
          }

          .or-table tbody tr.or-data-row .or-cell-product {
            font-weight: 700 !important;
            background: #f8fafc !important;
          }

          .or-table tbody tr.or-total-row {
            display: block !important;
            margin-top: 4px !important;
            border: 2px solid #94a3b8 !important;
            border-radius: 10px !important;
            overflow: hidden !important;
          }

          .or-table tbody tr.or-total-row td {
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            gap: 10px !important;
            width: auto !important;
            padding: 10px 12px !important;
            border: none !important;
            border-bottom: 1px solid rgba(148, 163, 184, 0.35) !important;
            text-align: right !important;
            font-size: 13px !important;
            background-color: #e5e7eb !important;
          }

          .or-table tbody tr.or-total-row td:last-child {
            border-bottom: none !important;
          }

          .or-table tbody tr.or-total-row td::before {
            content: attr(data-label) !important;
            font-weight: 700 !important;
            color: #475569 !important;
            font-size: 12px !important;
            text-align: left !important;
            flex-shrink: 0 !important;
            margin-right: auto !important;
          }
        }
      `}</style>
    </div>
  );
}

export default OzelRaporlar;